<ng-container *transloco="let t; read: 'ime.manufacturing.cost-price-components'">
  <div *ngIf="(cpc$ | async) as cpc; else loading">
    <div class="modal-header" ngxModalDraggable>
      <h4 class="modal-title">{{t('Cost price component')}}</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="bsModalRef.dismiss()">
      </button>
    </div>
    <div class="modal-body">
      <mes-api-response-summary class="d-none" [response]="response"></mes-api-response-summary>
      <mes-cost-price-component-edit [cpc]="cpc" (changed)="onChanged($event)">
      </mes-cost-price-component-edit>
    </div>
    <mes-web-edit-modal-buttons [entityId]="entityId"
                                [hasDeleteButton]="!!entityId"
                                [isPristine]="isPristine$ | async"
                                [requiredPrivileges]="[PRIVILEGES.EditManufacturing]"
                                (deleteClick)="delete()"
                                (saveClick)="save($event)"
                                (addClick)="add()"
                                (cancelClick)="bsModalRef.dismiss()">
    </mes-web-edit-modal-buttons>
  </div>
  <ng-template #loading>{{t('Loading')}}...</ng-template>
</ng-container>
